import React, {memo, useCallback, useEffect, useState} from "react";
import TextField from "@mui/material/TextField";

function toDraftString(value) {
    if (value === null || value === undefined) {
        return '';
    }
    if (Array.isArray(value)) {
        return value.map((entry) => String(entry).trim()).filter(Boolean).join(', ');
    }
    if (typeof value === 'object') {
        return '';
    }
    return String(value);
}

/**
 * Text / number input: local draft; parent patch updates on change (and blur) when the string differs.
 */
const PreventativeCommittedTextField = memo(({
                                                 committedValue,
                                                 textFieldProps,
                                                 onCommit,
                                             }) => {
    const [draft, setDraft] = useState(() => toDraftString(committedValue));

    useEffect(() => {
        setDraft(toDraftString(committedValue));
    }, [committedValue]);

    const commitIfChanged = useCallback((nextDraft) => {
        const next = toDraftString(nextDraft);
        const prev = toDraftString(committedValue);
        if (next !== prev) {
            onCommit(next);
        }
    }, [committedValue, onCommit]);

    const handleChange = useCallback((e) => {
        const nextDraft = e.target.value;
        setDraft(nextDraft);
        commitIfChanged(nextDraft);
    }, [commitIfChanged]);

    const handleBlur = useCallback(() => {
        commitIfChanged(draft);
    }, [draft, commitIfChanged]);

    return (
        <TextField
            {...(textFieldProps || {})}
            value={draft}
            onChange={handleChange}
            onBlur={handleBlur}
            size="small"
            fullWidth
            variant="outlined"
        />
    );
});

export default PreventativeCommittedTextField;
